export const EXCLUDED_STUDIO_IDS = [105,107,106,108,44,45,46,47]